import React from 'react'
import Img from 'gatsby-image'

import LogoBanner from '../components/LogoBanner'

const Impressum = ({ data }) => (
  <div className="content-box">
    <h2>Impressum</h2>
    Der Kinderbetreuungsatlas wurde aus Mitteln des ELER – Europäischer Fonds
    für die Entwicklung des ländlichen Raums im Rahmen des Österreichischen
    Programms für ländliche Entwicklung 2014 bis 2020 finanziert.
    <br />
    <br />
    <LogoBanner data={data} />
    <h3>Projektleitung</h3>
    Mag.a Gabi Tremmel-Yakali, AK Burgenland
    <h3>Projektteam</h3>
    <p>
      <span className="bold">ÖIR Projekthaus GmbH </span>
      <br />
      Augasse 14<br />
      7011 Siegendorf
    </p>
    <p>
      Tel.: 0664 92 00 752<br />
      office@projekthaus.at <br />
      www.projekthaus.at
    </p>
    <p>
      Mag.a Cornelia Krajasits<br />
      DI Mateusz Galka<br />
      Michael Winkler, Bsc.<br />
      Franz Knipp (qnipp GmbH)
    </p>
    <h3>Offenlegung nach § 25 Mediengesetz und § 5 eCommerce-Gesetz</h3>
    <h3>Medieninhaber, Herausgeber und Eigentümer</h3>
    <p>
      Kammer für Arbeiter und Angestellte für das Burgenland<br />
      Wiener Straße 7, 7000 Eisenstadt<br />
      Telefon: +43 2682 740<br />
      Email: akbgld@akbgld.at
    </p>
    <p>
      <span className="bold">Zuständige Aufsichtsbehörde:</span>{' '}
      Bundesministerium für Arbeit, Soziales und Komsumentenschutz<br />
      <span className="bold">Anwendbare Rechtsvorschriften:</span> Bundesgesetz
      über die Kammern für Arbeiter und Angestellte und die Bundeskammer für
      Arbeiter und Angestellte (Arbeiterkammergesetz 1992 - AKG), BGBL 626/1991<br />
      <span className="bold">Vertretungsbefugtes Organ:</span> Gerhard
      Michalitsch, Präsident<br />
    </p>
    <h3>Haftungsausschluss</h3>
    <p>
      Wir bemühen uns um Aktualität, Vollständigkeit und Richtigkeit aller von
      den Arbeiterkammern betriebenen Webseiten und Applikationen. Trotzdem
      können wir keine Gewährleistung und/oder Haftung übernehmen. Die auf den
      Internetseiten sowie in den Rechnern und Applikationen enthaltenen
      Informationen und auch die sich dadurch ergebenden Berechnungen sind als
      allgemeine Information und nicht als Beratung zu verstehen. Sie ersetzen
      in keinem Fall eine persönliche Beratung durch einen unserer ExpertInnen.
      Ehe Sie konkrete Handlungen setzen, lassen Sie Ihren Fall eingehend durch
      unsere ExpertInnen überprüfen. Bei unseren Rechnern und Applikationen
      fügen wir immer auch den Aktualisierungsstand hinzu. Berücksichtigen Sie
      das Veröffentlichungsdatum.
    </p>
    <p>
      Wir übernehmen keine Haftung für allfällige Nachteile und/oder Schäden,
      die durch den Gebrauch der Internetseiten, Rechner und Applikationen der
      Internetauftritte der Arbeiterkammern entstehen könnten. Insbesondere ist
      jegliche Haftung für allenfalls fehlerhafte und unvollständige
      Informationen ausgeschlossen. Sofern ein gänzlicher Haftungsausschluss
      aufgrund der jeweils anzuwendenden Gesetzeslage nicht möglich ist, wird
      die Haftung auf Vorsatz und grobe Fahrlässigkeit begrenzt.
    </p>
    <p>
      Unsere Seiten enthalten Links auf externe Webseiten Dritter. Auf die
      Inhalte dieser verlinkten Webseiten haben wir keinen Einfluss. Für die
      Richtigkeit der Inhalte ist immer der jeweilige Anbieter oder Betreiber
      verantwortlich. Wir übernehmen auch hierfür keinerlei Haftung und/oder
      Gewährleistung.
    </p>
    <h3>Copyright</h3>
    <h3>Copyright für alle Beiträge bei AK Burgenland</h3>
    <p>
      Der Kinderbetreuungsatlas verwendet Bilder der Agentur{' '}
      <a href="https://de.fotolia.com/">www.fotolia.de</a>. Die Karten wurden
      inhaltlich und kartografisch von ÖIR-Projekthaus GmbH und technisch von
      Franz Knipp (qnipp GmbH) bearbeitet. Alle Rechte vorbehalten. Eine
      Übernahme von Karten und Texten bedarf der schriftlichen Zustimmung der
      AK, eine Übernahme von Bildern ist ausdrücklich nicht gestattet
    </p>
    <h3>Barrierefreiheit</h3>
    <p>
      Das Internet-Team der Arbeiterkammern ist um eine möglichst barrierefreie
      Zugänglichkeit zu seinen Internet-Angeboten bemüht und orientiert sich
      dabei an den Richtlinien WCAG 2.0 AA des WAI / W3C. Wir verbessern auch
      laufend die Zugänglichkeit zu unseren PDF-Dokumenten.
    </p>
    <p>
      Einfache Bedienung und bequeme Zugänglichkeit ist uns ein großes Anliegen.
      Wenn Ihnen Barrieren auffallen oder wenn Sie Schwierigkeiten haben, unsere
      pdfs zu benutzen, <a href="https://bgld.arbeiterkammer.at/ueberuns/kontakt/barrierefreiheit/Zugaenglichkeit_und_Meldung_von_Barrieren.html">
        teilen Sie uns das bitte mit
      </a>.
    </p>
  </div>
)

export default Impressum

export const pageQuery = graphql`
  query ImprintImageQuery {
    logoBannerSlice0: imageSharp(id: { regex: "/LogoBanner_0_0.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 118) {
        ...GatsbyImageSharpSizes
      }
    }
    logoBannerSlice1: imageSharp(id: { regex: "/LogoBanner_0_1.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 144) {
        ...GatsbyImageSharpSizes
      }
    }
    logoBannerSlice2: imageSharp(id: { regex: "/LogoBanner_0_2.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 116) {
        ...GatsbyImageSharpSizes
      }
    }
    logoBannerSlice3: imageSharp(id: { regex: "/LogoBanner_0_3.png/" }) {
      original {
        width
      }
      sizes(maxWidth: 169) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/Impressum.js